import { ActivatedRoute, Router } from '@angular/router';
import { PagingParams } from 'app/types/paging';
import { AccountService } from './../../model/services/api-services/account.service';
import { Handler } from 'app/types/handlers';
import { SearchConfig } from './../search-filter/search-filter.component';
import { Component, OnInit, AfterViewInit, ChangeDetectorRef, ChangeDetectionStrategy, EventEmitter, Output } from '@angular/core';

export type OrgListItem = { label: string, account_id: number }
export type OrgListing = Array<OrgListItem>;

@Component({
  selector: 'app-orgs',
  templateUrl: './orgs.component.html',
  styleUrls: ['./orgs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrgsComponent implements AfterViewInit {

  public size = 20;
  public start = 1;
  public count = 0;
  public get max():number {
    if(!this.data || this.data.length === 0) {
      return 0
    }
    let last = this.start + this.data.length-1;
    return last;
  }

  public data: OrgListing = [];
  public lastNewId = 0;

  public searchConfig: SearchConfig = {
    getItemLabel: (item: any): string => {
      return (item as OrgListItem).label;
    },
    searchHandler: (term: string, handler: Handler<Array<any>, void>) => {
      // ToDo: Implement search
      this.accountSvc.GetAccounts(this.paging, term).then((response) => {
        this.data = response.results;
        this.count = Number(response.count);
        this.size = Number(response.size);
        this.start = Number(response.start) + 1;
        this.Refresh();
      });
    }
  }
  get paging(): PagingParams {
    const params: PagingParams = {};
    params.start = Number(this.start) - 1;
    if (this.count > 0) params.count = this.count;
    params.size = this.size;
    return params;
  }

  @Output()
  onSelect = new EventEmitter<OrgListItem>();

  private _ready: boolean = false;
  constructor(
    private cdr: ChangeDetectorRef,
    private accountSvc: AccountService,
    private activeRouter:Router) { }
  ngAfterViewInit(): void {
    this._ready = true;

  }

  Next(start: number, _count?: number) {
    this.start = start;
  }
  Prev(start: number, _count?: number) {
    this.start = start;
  }
  Refresh() {
    if (!this._ready) return;
    this.cdr.detectChanges();
  }
  Select(item:OrgListItem) {
    this.activeRouter.navigateByUrl('/organization/'+item.account_id);
    this.onSelect.emit(item);
  }
}
